import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import {
	AnalyticsSpotlightCard as ItsmSpotlightCard,
	StyledSpotlight,
} from '@atlassian/jira-servicedesk-itsm-onboarding-common';
import {
	YOUR_WORK_TOUR_ANALYTICS_SOURCE_NAME,
	YOUR_WORK_TOUR_ANALYTICS_SPOTLIGHT_IDS,
	FIRST_USER_CREATED_JSM_PROJECT_CARD_SPOTLIGHT_TARGET_KEY,
} from '../../../../common/constants';
import messages from './messages';

type Props = {
	isOnlySpotlight?: boolean;
	onPrimary: () => void;
	onClose: () => void;
};

export const YourProjectSpotlight = ({ isOnlySpotlight = false, onPrimary, onClose }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<StyledSpotlight target={FIRST_USER_CREATED_JSM_PROJECT_CARD_SPOTLIGHT_TARGET_KEY}>
			<ItsmSpotlightCard
				sourceName={YOUR_WORK_TOUR_ANALYTICS_SOURCE_NAME}
				spotlightId={YOUR_WORK_TOUR_ANALYTICS_SPOTLIGHT_IDS.YOUR_PROJECT}
				heading={formatMessage(messages.spotlightTitle)}
				buttons={{
					primary: {
						text: formatMessage(
							isOnlySpotlight ? messages.spotlightOkButton : messages.spotlightNextButton,
						),
						onClick: onPrimary,
					},
					close: {
						onClick: onClose,
					},
				}}
				steps={isOnlySpotlight ? undefined : { current: 1, count: 2 }}
			>
				<p>{formatMessage(messages.spotlightBody)}</p>
			</ItsmSpotlightCard>
		</StyledSpotlight>
	);
};
